// extracted by mini-css-extract-plugin
export default {"sticker":"DangerSticker_sticker__Ut2UE","icon":"DangerSticker_icon__Fs-ba","text":"DangerSticker_text__JRES7","button":"DangerSticker_button__lbu7f"};